import numeral from "numeral"

export const formatPercent = (
  value: any,
  decimalPlaces?: number,
  removeParenthesis?: boolean,
) => {
  if (value === undefined || value === null) return "-"

  // Convert value to number if it's not already
  const numValue = typeof value === "number" ? value : Number(value)

  // Check if the conversion resulted in a valid number
  if (isNaN(numValue)) return "-"

  // Create the format string based on decimalPlaces
  const formatString =
    decimalPlaces === 0 ? "0%" : `0.${"0".repeat(decimalPlaces ?? 2)}%`

  return numeral(numValue.toFixed(8)).format(
    removeParenthesis ? formatString : `(${formatString})`,
  )
}
